import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledDomainContainer = styled.div`
    max-width: 260px;
    line-height: 20px;
    padding-top: 6px;
    & span {
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const StyledWebSiteLink = styled.a`
    padding-left: 5px;
    && svg,
    &&:hover svg {
        path {
            fill: ${colorsPalettes.carbon["0"]};
        }
    }
`;

export const StyledWebSite = styled(CenteredFlexRow)`
    color: ${colorsPalettes.carbon["0"]};
    .ItemIcon.ItemIcon--website {
        width: 24px;
        height: 24px;
        margin-right: 8px;
    }
`;
